import { Subject } from "rxjs";

export class BroadcastQueue {
  [name: string]: Subject<unknown>;
}
